export * from "./physician-portal-access.guard";
export * from "./physician-portal-auth.guard";
export * from "./route-guards";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/physician-portal/index.ts